import { BaseNotificationContextEnum } from './base-notification-context.enum';

/**
 * Customer notification context enum
 * @description Notification contexts specific to customer subjects
 */
export enum CustomerNotificationContextEnum {
	// Base contexts
	INSERTED = BaseNotificationContextEnum.INSERTED,
	UPDATED = BaseNotificationContextEnum.UPDATED,
	DELETED = BaseNotificationContextEnum.DELETED,

	// Customer-specific contexts
	ACTIVE = 'active',
	ON_HOLD = 'on_hold',
	CLOSED = 'closed',
}
